import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import enhance from './modules/enhance'
import online from './modules/online'
import permission from './modules/permission'
import equipment from './modules/equipment'
import workbench from './modules/workbench'
import reportTab from './modules/reportTab'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    enhance,
    online,
    equipment,
    workbench,
    reportTab
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
